import { render, staticRenderFns } from "./HomepageTestimonials.vue?vue&type=template&id=a4dccc70&scoped=true"
import script from "./HomepageTestimonials.vue?vue&type=script&lang=js"
export * from "./HomepageTestimonials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dccc70",
  null
  
)

export default component.exports